import { CustomerManagement } from "@/components/CustomerManagement";

export default function CustomersPage() {
  return <CustomerManagement />;
}


